"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChartConstants = /** @class */ (function () {
    function ChartConstants() {
    }
    //Tabs
    ChartConstants.allTabs = [
        {
            id: "1",
            title: "Hoje"
        },
        {
            id: "7",
            title: "7 dias"
        },
        {
            id: "30",
            title: "30 dias"
        },
        {
            id: "60",
            title: "60 dias"
        },
    ];
    //Tabs
    ChartConstants.tabs = [
        {
            id: "7",
            title: "7 dias"
        },
        {
            id: "30",
            title: "30 dias"
        },
        {
            id: "60",
            title: "60 dias"
        },
    ];
    //Tabs
    ChartConstants.tabsReduced = [
        {
            id: "7",
            title: "7 dias"
        },
        {
            id: "30",
            title: "30 dias"
        },
    ];
    return ChartConstants;
}());
exports.default = ChartConstants;
//# sourceMappingURL=chart.js.map